
import { defineComponent } from "vue";
import getScoreColorClass from "@/helper/scoreColorClass";

export default defineComponent({
  name: "HighscoreDisplay",

  components: {},

  data() {
    return {};
  },

  props: {
    gameName: {
      type: String,
      default: "",
    },
  },

  computed: {
    currentHighscore() {
      return this.$store.getters.getHighscoreByGameName(this.gameName);
    },
    hasHighscore() {
      return this.$store.getters.hasHighscore(this.gameName);
    },
    extraPointsClasses() {
      return getScoreColorClass(this.currentHighscore, this.gameName);
    },
    isTimeScore() {
      return (
        this.$store.getters.getScoreTypeByGameName(this.gameName) === "time"
      );
    },
  },

  methods: {},
});
